export interface Breadcrumb {
  label: string;
  url?: string | null;
}

export default {
  addBreadcrumb({ commit, state }, crumb: Breadcrumb) {
    // Prevent adding duplicate crumbs
    if (state.breadcrumbs.some((c) => c.label === crumb.label)) return;
    setTimeout(() => {
      commit("replace", {
        state: "breadcrumbs",
        data: state.breadcrumbs.concat([crumb])
      });
    });
  },
  removeBreadcrumb({ commit, state }, crumb: Breadcrumb) {
    // Remove by label
    commit("replace", {
      state: "breadcrumbs",
      data: state.breadcrumbs.filter((_crumb) => _crumb.label === crumb.label)
    });
  },
  setBreadcrumbs({ commit }, crumbs: Breadcrumb[]) {
    commit("replace", {
      state: "breadcrumbs",
      data: crumbs
    });
  }
};
